import { useCondicoesAutorreferidasQuery } from 'graphql/hooks.generated'
import React from 'react'
import { CondicoesAutorreferidasCard } from 'view/atendimentos/detail/soap/aside/condicoes-autorreferidas/CondicoesAutorreferidasCard'

import { AcompanhamentoCard } from '../../components/AcompanhamentoCard'

export interface AutorreferidasCardProps {
  cidadaoId: ID
}

export function AutorreferidasCard(props: Readonly<AutorreferidasCardProps>) {
  const { cidadaoId } = props

  const {
    data: { condicoesAutorreferidas },
    loading,
  } = useCondicoesAutorreferidasQuery({
    fetchPolicy: 'cache-first',
    variables: {
      cidadaoId: cidadaoId,
    },
  })

  const hasCondicoesAutorreferidas = condicoesAutorreferidas?.length > 0

  return (
    <AcompanhamentoCard
      id='condicoes-autorreferidas'
      title='Problemas/condições autorreferidas'
      placeholder='Nenhum problema/condição autorreferida registrada'
    >
      {hasCondicoesAutorreferidas && (
        <CondicoesAutorreferidasCard
          condicoesAutorreferidas={condicoesAutorreferidas}
          loading={loading}
          canRender={hasCondicoesAutorreferidas}
        />
      )}
    </AcompanhamentoCard>
  )
}
